<template>
  <!-- 历史任务 -->
  <div style="position: relative;">
    <el-form style="margin:5px 0" ref="formMyHistoryTask" :model="formFilter" label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="工单状态" prop="flowStatus">
            <el-select style="width:100%" v-model="formFilter.flowStatus" placeholder="工单状态" clearable>
              <el-option v-for="item in SysFlowWorkOrderStatus.getList()" v-show="item.name !== '已结束' && item.name !== '已撤销' && item.name !== '暂存'" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="审核时间" prop="auditDate">
            <el-date-picker style="width:100%" v-model="formFilter.auditDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable value-format="yyyy-MM-dd" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目名称" prop="projectName">
            <el-select style="width:100%" filterable  :clearable="true" v-model="formFilter.projectName" placeholder="项目名称">
              <el-option
                v-for="(item,index) in projectList"
                :key="index"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供货方名称" prop="supplierName">
            <el-input
              v-model="formFilter.supplierName"
              :clearable="true" placeholder="供货方名称"
            />
          </el-form-item>
        </el-col>
        <!-- 仅"全部工作"页签显示（"由我创建"传 doType=2） -->
        <el-col v-if="doType !== 2" :span="8">
          <el-form-item label="审核人" prop="approverValue">
            <el-select style="width:100%" v-model="formFilter.approverValue" filterable clearable placeholder="请选择审核人" @change="handleApproverChange">
              <el-option
                v-for="item in approverList"
                :key="item.kind + '-' + item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-button type="primary" :plain="true" :size="defaultFormItemSize" @click="handleSearch">查询</el-button>
            <el-button type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="teacher" :data="formMyHistoryTaskWidget.dataList" :size="defaultFormItemSize" @sort-change="formMyHistoryTaskWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="formMyHistoryTaskWidget.getTableIndex" />
          <el-table-column label="流程名称" prop="processDefinitionName" width="200px"  />
          <el-table-column label="项目名称" prop="masterData.project_name" width="600px" show-overflow-tooltip />
          <el-table-column label="供货方名称" prop="masterData.supplier_name" width="200px" show-overflow-tooltip />
          <el-table-column label="合同编号" prop="masterData.contract_no" width="200px" show-overflow-tooltip />
          <el-table-column label="合同金额" prop="masterData.contract_amount" width="150px" show-overflow-tooltip />
          <el-table-column label="供货方名称" prop="masterData.supplier_name" width="200px" show-overflow-tooltip />
          <el-table-column label="审核时间" prop="masterData.auditTime" width="200px"  />
          <el-table-column label="发起人" prop="userShowName" width="200px" show-overflow-tooltip />
          <el-table-column label="发起时间" prop="createTime" width="200px"  />
          <el-table-column label="状态" prop="flowStatusName">
            <template slot-scope="scope">
               <span v-if="scope.row.isReject" style="color:red">退回</span>
               <span v-else :style="{'color':color[scope.row.flowStatusName]}">{{scope.row.flowStatusName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope">
              <el-button class="table-btn" :size="defaultFormItemSize" type="text" @click="getFlow(scope.row)">流程图</el-button>
              <el-button class="table-btn success"  :size="defaultFormItemSize" type="text" @click="onFlowDetail(scope.row)">详情</el-button>
              <el-button v-if="doType === 2 && scope.row.flowStatus === 0 && !scope.row.isReject" class="table-btn delete"  :size="defaultFormItemSize" type="text" @click="handleWithdraw(scope.row)">撤回</el-button>
              <el-button v-if="doType === 2 && (scope.row.isReject || scope.row.flowStatus === 5 || scope.row.flowStatus === -1)" class="table-btn delete"  :size="defaultFormItemSize" type="text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="formMyHistoryTaskWidget.totalCount"
            :current-page="formMyHistoryTaskWidget.currentPage"
            :page-size="formMyHistoryTaskWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="formMyHistoryTaskWidget.onCurrentPageChange"
            @size-change="formMyHistoryTaskWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog
      :visible="visible"
      width="1000px"
      top='5vh'
      :before-close="onClose"
    >
      <formTaskProcessViewer v-if="record.processDefinitionId && visible"  :flag="false"  :processDefinitionId='record.processDefinitionId'  :processInstanceId='record.processInstanceId' />
    </el-dialog>

  </div>
</template>

<script>

import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { TableWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { FlowOperationController } from '@/api/flowController.js';
import { ContractDeptController } from '@/api/index.js';
import {SysFlowWorkOrderStatus} from "@/staticDict/flowStaticDict";
import formTaskProcessViewer from "./formTaskProcessViewer.vue";
import { OnlineOperation } from '@/api/onlineController.js';
export default {
  name: 'formMyHistoryTask',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  components:{
    formTaskProcessViewer
  },
  props:{
    options:{
      type :Array,
      default : () => []
    },
    doType:{
      type:Number
    }
  },
  data () {
    return {
      formFilter: {
        flowStatus: undefined,
        auditDate: undefined,
        projectName: undefined,
        supplierName: undefined,
        approverValue: undefined,
        approverKind: undefined
      },
      formFilterCopy: {
        flowStatus: undefined,
        auditDate: undefined,
        projectName: undefined,
        supplierName: undefined,
        approverValue: undefined,
        approverKind: undefined
      },
      formMyHistoryTaskWidget: new TableWidget(this.loadMyHistoryTaskData, this.loadMyHistoryTaskVerify, true, false,null,false,null,localStorage.getItem('page') ? JSON.parse(localStorage.getItem('page')).pageParam.pageNum : 1),
      isInit: false,
      record:{

      },
      visible:false,
      projectList:[],
      approverList: [],
       color:{ '处理中' : 'rgb(0, 128, 0)','审批中' : 'rgb(0, 128, 0)','已拒绝' : 'rgb(0, 128, 0)','已办结' : 'rgb(255, 0, 0)','已结束' : 'rgb(255, 0, 0)', '已撤销' : '#999','暂存':'#000'}, //任务状态color
    }
  },
  created() {
    this.formFilter.doType = this.doType
    this.formFilter.formFilterCopy = this.doType
    this.init()
    // 审核人筛选仅"全部工作"页签需要（"由我创建"传 doType=2，不请求下拉数据）
    if (this.doType !== 2) this.initApproverList()
    const row = JSON.parse(localStorage.getItem('task'))
    if (row) {
      this.onFlowDetail(row)
    }
    const search = JSON.parse(localStorage.getItem('search'))
    if (search) {
      this.formFilter = search
      this.formFilterCopy = search
    }
  },
  mounted() {
    localStorage.removeItem('page')
  },
  destroy () {
      this.formFilter = {
        flowStatus: undefined,
        auditDate: undefined,
        projectName: undefined,
        supplierName: undefined,
        approverValue: undefined,
        approverKind: undefined
      }
      this.formFilterCopy = {
        flowStatus: undefined,
        auditDate: undefined,
        projectName: undefined,
        supplierName: undefined,
        approverValue: undefined,
        approverKind: undefined
      }
  },
  methods: {
    handleSearch(){
      this.refreshFormMyHistoryTask(true)
      localStorage.removeItem('page')
    },
    init(){
      OnlineOperation.listDict(this, {
        dictId: '1637650160030846976'
      }).then(res=>{
        this.projectList = res.data
      })
    },
    /**
     * 审核人下拉数据：/admin/upms/contractDept/listApprove
     * 返回行结构：{ id, name, type }，type = 'dept' | 'user'
     * 部门行（type='dept'，如"合同管理部"）：选项值绑部门名称 name，查询参数 currentApprovalDeptName 传 name
     * 人员行（type='user'，如"张磊"）：选项值绑 id，查询参数 currentApproverUserId 传 id
     */
    initApproverList(){
      ContractDeptController.listApprove(this, {}).then(res => {
        const rows = Array.isArray(res.data) ? res.data : (((res.data || {}).dataList) || [])
        this.approverList = rows.map(item => {
          const kind = this.getApproverKind(item)
          const name = item.name || item.userName || item.deptName || item.label
          // 部门行选项值绑部门名称；人员行选项值绑 id
          const value = kind === 'dept' ? (item.deptName || item.name) : (item.userId || item.id)
          return { kind, name, value }
        }).filter(item => item.name && item.value != null)
        // 从本地缓存恢复查询条件时，若缺省类型标识，则按下拉数据反推
        if (this.formFilter.approverValue && !this.formFilter.approverKind) {
          const hit = this.approverList.find(item => String(item.value) === String(this.formFilter.approverValue))
          if (hit) this.formFilter.approverKind = hit.kind
        }
      })
    },
    getApproverKind(item){
      return String(item.type) === 'dept' ? 'dept' : 'user'
    },
    getApproverKindByValue(value){
      const hit = this.approverList.find(item => String(item.value) === String(value))
      return hit ? hit.kind : undefined
    },
    handleApproverChange(value){
      // 选中项是部门名称 -> 查询参数 currentApprovalDeptName 传 name；
      // 否则为审核人 -> 查询参数 currentApproverUserId 传 id
      this.formFilter.approverKind = value ? this.getApproverKindByValue(value) : undefined
    },
    onReset () {
      this.formFilter = {
        flowStatus: undefined,
        auditDate: undefined,
        projectName: undefined,
        supplierName: undefined,
        approverValue: undefined,
        approverKind: undefined
      }
      this.formFilterCopy = {
        flowStatus: undefined,
        auditDate: undefined,
        projectName: undefined,
        supplierName: undefined,
        approverValue: undefined,
        approverKind: undefined
      }
      this.refreshFormMyHistoryTask(true);
      localStorage.removeItem('search')
    },
    // 删除
    handleDelete(record){
      this.$confirm('是否删除此工单？').then(res => {
        FlowOperationController.deleteRecord(this,{processInstanceId:record.processInstanceId}).then(res => {
          this.formMyHistoryTaskWidget.refreshTable();
          this.$message.success('删除成功！');
        })
      }).catch(e => {});
    },
    // 撤回
    handleWithdraw(record){
      if(!record.runtimeTaskInfoList.length) return
      this.$confirm('是否撤回此工单？').then(res => {
        const data = {
          taskId:record.runtimeTaskInfoList[0].taskId,
          processInstanceId:record.processInstanceId,
          comment:'撤回'
        }
        FlowOperationController.withdraw(this,data).then(res => {
          this.formMyHistoryTaskWidget.refreshTable();
          this.$message.success('撤回成功！');
        })
      }).catch(e => {});
    },
    /**
     * 获取所有流程实例
     */
    loadMyHistoryTaskData (params) {
      if (params == null) params = {};
      if(params.pageParam.pageNum !== 1) {
        localStorage.setItem('page',JSON.stringify(params))
      } else {
        localStorage.removeItem('page')
      }
      const auditDate = this.formFilterCopy.auditDate;
      const approverValue = this.formFilterCopy.approverValue;
      const approverKind = this.formFilterCopy.approverKind;
      params = {
        ...params,
        flowWorkOrderDtoFilter:{
          flowStatus: this.formFilterCopy.flowStatus,
          doType: this.doType,
          beginDate: auditDate ? auditDate[0] + ' 00:00:00' : undefined,
          endDate: auditDate ? auditDate[1] + ' 23:59:59' : undefined,
          projectName: this.formFilterCopy.projectName,
          supplierName: this.formFilterCopy.supplierName,
          // 选中项是部门名称 -> 传部门名称；否则为具体审核人 -> 传 id
          currentApprovalDeptName: approverKind === 'dept' ? approverValue : undefined,
          currentApproverUserId: approverKind === 'user' ? approverValue : undefined
        }
      }

      return new Promise((resolve, reject) => {
        ContractDeptController.listWorkOrder(this, params).then(res => {
          if (res.data.dataList.length > 0) {
            res.data.dataList.forEach(item => {
              item.flowStatusName = SysFlowWorkOrderStatus.getValue(item.flowStatus)
            })
          }
          this.dataList = res.data.dataList
          this.total = res.data.totalCount
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadMyHistoryTaskVerify () {
      this.formFilterCopy.flowStatus = this.formFilter.flowStatus
      this.formFilterCopy.auditDate = Array.isArray(this.formFilter.auditDate) ? [...this.formFilter.auditDate] : undefined
      this.formFilterCopy.projectName = this.formFilter.projectName
      this.formFilterCopy.supplierName = this.formFilter.supplierName
      this.formFilterCopy.approverValue = this.formFilter.approverValue
      this.formFilterCopy.approverKind = this.formFilter.approverKind
      return true;
    },
    refreshFormMyHistoryTask (reloadData = false) {
      if (reloadData) {
        this.formMyHistoryTaskWidget.refreshTable(true, 1);
      } else {
        this.formMyHistoryTaskWidget.refreshTable();
      }
      if (!this.isInit) {
        // 初始化下拉数据
      }
      this.isInit = true;
      localStorage.setItem('search',JSON.stringify(this.formFilterCopy))
    },
    onFlowDetail (row) {
      localStorage.setItem('task',JSON.stringify(row))
      let params = {
        processInstanceId: row.processInstanceId
      }
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              serialNo:row.serialNo,
              processDefinitionKey: row.processDefinitionKey,
              taskId: null,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              flag: false, // change wang 2023/3/10
              flowStatus: row.flowStatusName,
              form:true
            }
          });
        }
      }).catch(e => {});
    },
    onResume () {
      this.refreshFormMyHistoryTask();
    },
    initFormData () {
    },
    formInit () {
      this.refreshFormMyHistoryTask();
    },
    // 查看流程图
    getFlow(record){
      this.record = record
      this.visible = true
    },
    onClose(){
      this.visible = false
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style>
</style>
